/**
 * Strips a file or folder name down to the characters mops-api accepts in an
 * asset key: whitespace becomes `-`, anything outside `[A-Za-z0-9._-]` is
 * dropped, and leading dots go so the result cannot be a hidden file.
 */
export function sanitizeFileName(name: string): string {
  return name
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^A-Za-z0-9._-]/g, '')
    .replace(/^\.+/, '');
}

/** The S3 key a file lands at, or an empty string when nothing usable survives sanitizing. */
export function buildStaticAssetKey(fileName: string): string {
  return sanitizeFileName(fileName);
}

/** Browsers leave `type` empty for extensions they don't know; S3 needs something to sign. */
export function contentTypeForFile(file: Pick<File, 'type'>): string {
  return file.type || 'application/octet-stream';
}

/** PUTs the file body to a presigned S3 URL. The content type must match what the URL was signed for. */
export async function uploadFileToPresignedUrl(uploadUrl: string, file: Blob, contentType: string): Promise<void> {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': contentType },
  });
  if (!response.ok) {
    throw new Error(`Upload failed with HTTP ${response.status}`);
  }
}
